<template>
    <div>
        <div class="form-message search" :class="{ 'active' : noResultsMap, 'has-filters' : showDurationFilter }">
            Inget resultat
        </div>
        <div class="btn-fixed btn-position active" :class="{ 'loading' : loadingPosition }" @click="triggerSetCurrentLocation()"></div>
        <div class="btn-fixed btn-maptype active" @click="changeMapType()">
            <img src="/images/card/maptype.svg">
            <span v-if="mapType == 'hybrid'">Karta</span>
            <span v-else>Satellit</span>
        </div>
        <div class="view-container" :id="'map_container_'+id"></div>
    </div>
</template>

<script>

import uniqid from 'uniqid'
import Cookies from 'js-cookie'

export default {

    props: {
        loading: {
            required: true
        },
        clinics: {
            required: true
        },
        showDurationFilter: {
            required: true
        },
        hasActiveSearch: {
            required: true
        },
        filters: {
            required: true
        }
    },

    data () {
        return {
            id: uniqid(),
            map: null,
            bounds: null,
            markers: [],
            loadingPosition: false,
            noResultsMap: false,
            mapType: 'hybrid'
        }
    },

    mounted () {
        if (Cookies.get('mapType') == 'hybrid') {
            this.mapType = 'hybrid'
        }

        if (Cookies.get('mapType') == 'roadmap') {
            this.mapType = 'roadmap'
        }

        this.createLargeMap()

        if (this.filters.product_area !== 2)
        {
            this.setCurrentLocation()   
        }

        this.setMarkers()
    },

    watch: {
        clinics () {
            this.setMarkers()
        },
        loading () {
            if (this.clinics.length === 0 && !this.loading) {
                this.noResultsMap = true
                setTimeout(() => {
                    this.noResultsMap = false
                }, 3000)
            }
        },
        '$route' (to, from) {
            if (to.name === 'booking' && from.name !== 'modal-clinic' && from.name !== 'modal-address') {
                this.setMarkers()
            }
        }
    },

    methods: {

        createLargeMap () {
            this.map = new google.maps.Map(document.getElementById('map_container_' + this.id), {
                center: { lat: 61.1740832, lng: 15.2460806 },
                zoom: 6,
                minZoom: 4,
                mapTypeId: this.mapType,
                disableDefaultUI: true,
                zoomControl: false,
                scaleControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                gestureHandling: 'greedy',
                mapId: 'f98e1e78919c6a51',
                styles: [
                    {
                        featureType: 'poi',
                        stylers: [{ visibility: 'off' }]
                    }
                ]
            })

            this.map.addListener('zoom_changed', () => {
                this.setDetailsClass()
            })
        },

        setDetailsClass () {
            const zoom = this.map.getZoom()

            if (zoom) {
                // console.log('zoom', zoom)
                this.markers.forEach(marker => {
                    if (zoom <= 12) {
                        // console.log('remove details class')
                        marker.content.classList.remove('details')
                    } else {
                        // console.log('add details class')
                        marker.content.classList.add('details')
                    }
                })
            }
        },

        setMarkers () {
            this.bounds = new google.maps.LatLngBounds()

            this.markers.forEach(m => m.setMap(null))
            this.markers = []

            this.clinics.forEach((clinic) => {
                const coordinates = clinic.address.coordinates.split(' ')
                const lat = parseFloat(coordinates[0])
                const lng = parseFloat(coordinates[1])

                const clinicsOnAddress = this.clinics.filter(c => clinic.address_id === c.address_id)
                const indexOfClinic = clinicsOnAddress.findIndex(c => clinic.id === c.id)

                let extraClass1 = ''
                let extraClass2 = ''
                let zIndex = 0

                if (clinicsOnAddress.length === 2 && indexOfClinic === 0) {
                    extraClass1 = 'two'
                    extraClass2 = 'two-left'
                    zIndex = 2
                }
                if (clinicsOnAddress.length === 2 && indexOfClinic === 1) {
                    extraClass1 = 'two'
                    extraClass2 = 'two-right'
                    zIndex = 1
                }
                if (clinicsOnAddress.length === 3 && indexOfClinic === 0) {
                    extraClass1 = 'three'
                    extraClass2 = 'three-left'
                    zIndex = 3
                }
                if (clinicsOnAddress.length === 3 && indexOfClinic === 1) {
                    extraClass1 = 'three'
                    extraClass2 = 'three-center'
                    zIndex = 2
                }
                if (clinicsOnAddress.length === 3 && indexOfClinic === 2) {
                    extraClass1 = 'three'
                    extraClass2 = 'three-right'
                    zIndex = 1
                }

                if (clinic.practitioner_thumbs.length > 1) {
                    extraClass1 = 'combined'
                    if (clinic.practitioner_thumbs.length == 2) {
                        extraClass2 = 'combined-two'
                        zIndex = 1
                    }

                    if (clinic.practitioner_thumbs.length > 2) {
                        extraClass2 = 'combined-three'
                        zIndex = 1
                    }
                }

                const marker = new google.maps.marker.AdvancedMarkerElement({
                    map: this.map,
                    position: { lat: lat, lng: lng },
                    content: this.buildMarker(clinic, extraClass1, extraClass2),
                    zIndex: zIndex
                })

                marker.addListener('click', () => {
                    this.matomoTrackEvent('Booking', 'Open clinic', 'Map')

                    if (clinicsOnAddress.length > 1) {
                        this.$router.push({ name: 'modal-address', params: { address: clinic.address_id } })
                    } else {
                        this.$router.push({ name: 'modal-clinic', params: { clinic: clinic.id } })
                    }
                })

                this.bounds.extend(marker.position)

                this.markers.push(marker)
            })

            this.setDetailsClass()

            if (this.markers.length === 1) {
                this.map.setZoom(16)
                this.map.setCenter(this.markers[0].position)
                return
            }
            if (this.filters.product_area === 2)
            {
                this.map.setZoom(13)
                this.map.setCenter({lat:59.3450024, lng:18.0413523})
                return
            }
            if (this.markers.length > 1 && this.hasActiveSearch) {
                this.map.fitBounds(this.bounds)
            }

        },

        buildMarker (clinic, extraClass1, extraClass2) {
            const content = document.createElement('div')

            let html = '<img class="logotype" src="/images/card/halsoresurs-icon.svg">'

            if (clinic.practitioner_thumbs.length > 1) {
                let pcount = 1
                clinic.practitioner_thumbs.forEach((practitioner_thumb) => {
                    if (pcount < 4) {
                        html += '<img class="image-mask mask-' + pcount + '" src="' + practitioner_thumb + '">'
                    }
                    pcount++
                })
            } else if (clinic.portrait) {
                html += '<img class="image-portrait" src="' + clinic.portrait.marker_url + '">'
            }

            if (clinic.survey_score && clinic.survey_count > 2 && clinic.show_survey_score === 1) {
                html += '<div class="marker-tab">'
                html += '<img src="/images/card/review-heart.svg" class="survey-heart">'
                html += clinic.survey_score
                html += '</div>'
            } else if (clinic.isNewCached === true) {
                html += '<div class="marker-tab new-clinic">Ny</div>'
            }

            content.classList.add('marker-wrapper')
            if (extraClass1 != '') {
                content.classList.add(extraClass1)
                content.classList.add(extraClass2)
            }
            content.innerHTML = html

            return content
        },

        triggerSetCurrentLocation () {
            this.matomoTrackEvent('Booking', 'Position', '')
            this.setCurrentLocation()
        },

        setCurrentLocation () {
            this.loadingPosition = true

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }
                    this.map.setCenter(pos)
                    this.map.setZoom(14)
                    this.loadingPosition = false
                }, () => {
                    this.loadingPosition = false
                }
                )
            } else {
                this.loadingPosition = false
                // Browser doesn't support Geolocation
                // handleLocationError(false, infoWindow, map.getCenter());
            }
        },

        changeMapType () {
            if (this.mapType == 'hybrid') {
                this.mapType = 'roadmap'
            } else {
                this.mapType = 'hybrid'
            }
            this.map.setMapTypeId(this.mapType)
            Cookies.set('mapType', this.mapType, { expires: 1500 })

            const mapTypeNice = this.mapType === 'hybrid' ? 'Satellite' : 'Map'
            this.matomoTrackEvent('Booking', 'Maptype', mapTypeNice)
        }

    }
}
</script>

<style>
.marker-wrapper {
    width: 44px;
    height: 50px;
    position: relative;
    background-image: url('/images/card/pointer-bg-shadow.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transition:transform 300ms ease;
    transform-origin: bottom center;

    display: flex;
    justify-content: center;
    align-items: center;

    .logotype {
        width: 14px;
        margin-top: -10px;
        z-index: 2;
    }

    .image-portrait {
        display: none;
        position: absolute;
        z-index: 3;
        top: 4px;
        left: 3px;
        width: 36px;
    }

    .marker-tab {
        display: none;
        position: absolute;
        z-index: 1;
        top: 12px;
        left: -10px;
        padding: 4px 8px 4px 24px;
        align-items: center;
        background-color: #fff;
        border-radius: 6px;
        font-size: 14px;
        font-weight:500;

        .survey-heart {
            width: 16px;
            margin-right: 4px;
        }
    }

    .marker-tab.new-clinic {
        color:#e09400;
    }

    &.combined {

        .image-mask
        {
            display:none;
        }

    }

}

.marker-wrapper.details {
    width: 70px;
    height: 79px;
    border-radius:30px 30px 50px 50px;

    .logotype {
        width: 22px;
        margin-top: -16px;
        z-index: 2;
    }

    .image-portrait {
        display: block;
        top: 8px;
        left: 5px;
        width: 60px;
    }

    .marker-tab {
        display: flex;
        top: 30px;
        left: 35px;
    }

    &.two, &.three
    {
        width: 50px;
        height: 69px;
        background-size: 70px;
        border-radius:40px 40px 100% 100%;

        .image-portrait {
            top: 3px;
            left: -5px;
            width: 60px;
        }

    }

    &.three
    {
        .marker-tab
        {
            display: none;
        }
    }

    &.two-left {
        transform: rotate(-30deg) translateX(-4px);

        .marker-tab {
            top: -3px;
            left: auto;
            right:28px;
            padding: 4px 24px 4px 8px;
            transform: scaleX(1) rotate(30deg);
        }
    }

    &.two-right {
        transform: rotate(30deg) translateX(4px);

        .marker-tab {
            top: 0px;
            left: 28px;
            transform: scaleX(1) rotate(-30deg);
        }
    }

    &.three-left {
        transform: rotate(-58deg);
    }
    &.three-center {
        transform: translate(0,-10px);
    }
    &.three-right {
        transform: rotate(58deg);
    }

    &.combined {

        width: 90px;
        height: 102px;
        border-radius:30px 30px 50px 50px;

        .logotype {
            display:none;
        }

        .image-mask
        {
            position: absolute;
            display: block;
            mask-repeat:no-repeat;
            mask-position:center center;
            z-index:4;
        }

        &.combined-two
        {
            .image-mask.mask-1
            {
                mask-image: url('/images/card/mask-half-1.png');
                mask-size:25px 76px;
                top:11px;
                left:-7px;
                width:76px;
                height: 76px;
            }

            .image-mask.mask-2
            {
                mask-image: url('/images/card/mask-half-2.png');
                mask-size:25px 76px;
                top:11px;
                left:auto;
                right:-7px;
                width:76px;
                height: 76px;
            }
        }

        &.combined-three
        {

            .image-mask.mask-1
            {
                mask-image: url('/images/card/mask-third-new-1.png');
                mask-size:26px 34px;
                top:3px;
                left:5px;
                width:50px;
                height:50px;
            }

            .image-mask.mask-2
            {
                mask-image: url('/images/card/mask-third-new-2.png');
                mask-size:26px 34px;
                top:3px;
                left:auto;
                right:5px;
                width:50px;
                height:50px;
            }

            .image-mask.mask-3
            {
                mask-image: url('/images/card/mask-third-new-3.png');
                mask-size:50px 40px;
                top:43px;
                left:20px;
                width:50px;
                height: 50px;
            }

        }

        .marker-tab {
            top: 40px;
            left: 58px;
        }

    }

}
</style>
